"use strict";

var Prompt = require("./prompt");

var PromptContainer = React.createClass({
  propTypes: {
    onClose: React.PropTypes.func,
    dismissable: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return ({
      onClose: null,
      dismissable: true
    });
  },
  getInitialState: function () {
    return({
      isOpen: true,
      errorMsg: null
    });
  },
  showError: function (message) {
    this.setState({
      errorMsg: message
    });
  },
  close: function () {
    if (this.props.dismissable === false)
      return;

    this.setState({
      isOpen: false
    });
    if (this.props.onClose) {
      this.props.onClose(ReactDOM.findDOMNode(this));
    }
  },
  render: function () {
    return (
      <Prompt
        {...this.props}
        onClose={this.close}
        isOpen={this.state.isOpen}
        errorMsg={this.state.errorMsg}
      />
    );
  }
});

module.exports = PromptContainer;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt-container.jsx